import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { SessionData } from 'src/app/domain/session-data';
import { URL_CAPTCHA } from 'src/app/shared/config-urls';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {
  httpArg: {};

  constructor(private httpService: HttpService) { }

  validateCaptcha(captchaResponse: string, sessionData: SessionData) {
    return this.httpService.post<any>(
      `${URL_CAPTCHA}`, this.getCaptchaValidationBody(captchaResponse), sessionData.agreementMap);
  }

  getCaptchaValidationBody(captchaResponse: string) {
    return this.httpArg = {
      'validateCaptcha': {
        'captchaResponse': captchaResponse
      }
    };
  }
}
